<template>
  <div>
    <Modal v-model="isShow" width="65%"  hight="80%" :closable="false" :mask-closable="false" :footerHide="true">
      <div>
        <div slot="header" class="info-header">
          <div class="ivu-modal-header-inner">隐私政策</div>
          <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
        </div>
        <h4> 更新时间：2023/4/3</h4>
        <h4> 一、 导言</h4>
        1.1 为切实保护悟耘智析（以下统称“智析”）的用户隐私权，优化用户体验，智析根据现行法规及政策，制定本《隐私政策》。
        本《隐私政策》将详细说明智析在获取、管理及保护用户个人信息方面的政策及措施。本《隐私政策》适用于智析向您提供的所有服务，无论您是通过计算机设备、移动终端或其他设备获得的服务。
        1.2 对于本《隐私政策》或相关事宜有任何问题，您可随时通过访问智析在线客服系统、智析官方服务账号或拨打我们的任何一部客服电话等多种方式与我们联系。
        1.3 本《隐私政策》部分将帮助您了解以下内容：
        （1） 我们如何收集和使用您的个人信息；
        （2） 我们如何使用 Cookie 和同类技术；
        （3） 我们如何共享、转让、公开披露您的个人信息；
        （4） 我们如何保护您的个人信息；
        （5） 您如何管理您的个人信息；
        （6） 我们如何处理未成年人的个人信息；
        （7） 本《隐私政策》如何修改；
        （8） 争议解决。
        1.4
        本《隐私政策》是您使用智析服务及各项功能的基础性法律文件，我们希望您在使用智析服务前仔细阅读并明确您已经充分理解、接受本政策的内容，希望您可以根据自己的理解做出合适的选择。我们努力通过通俗的语言表述本《隐私政策》中涉及的相关术语，并提供进一步说明的链接，以便您更好地理解。在我们更新本《隐私政策》后（我们会及时提示您更新的情况）您继续使用我们的产品与/或服务，即意味着您同意本《隐私政策》(含更新版本)内容，并且同意我们按照本《隐私政策》收集、使用、保存和共享您的相关信息。
        1.5
        本《隐私政策》涉及的个人信息包括：基本信息（包括个人姓名、生日、性别、住址、个人电话号码、电子邮箱）；个人身份信息（包括身份证、军官证、护照、驾驶证、相关身份证明等）；个人位置信息；网络身份标识信息（包括系统账号、IP地址、邮箱地址及与前述有关的密码、密保）；通讯录；个人上网记录（包括搜索记录、软件使用记录、点击记录）；个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码（如IMEI/android
        ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）；
        1.6
        个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，本《隐私政策》中涉及的个人敏感信息包括：个人身份信息（包括身份证、军官证、护照、驾驶证、户口本）；网络身份识别信息（包括账户名、账户昵称、邮箱地址及与前述有关的密码与密码保护问题和答案）；其他信息（包括通讯录、个人电话号码、手机号码、行程信息、网页浏览记录、精准定位信息、银行账户）；相关身份证明；
        <h4>二、 个人信息的收集</h4>
        2.1
        您已知悉且同意，在您注册智析账号或使用智析提供的服务时，智析将记录您提供的相关个人信息，如：密码、手机号码等，上述个人信息是您获得智析提供服务的基础。同时，基于优化用户体验之目的，智析会获取与提升智析服务有关的其他信息，例如当您访问智析时，我们可能会收集哪些服务的受欢迎程度、浏览器软件信息等以便优化我们的服务。
        2.2 在您使用智析前，我们会引导您阅读本协议，并在您接受本协议的基础上，获得您的相关个人信息，未获得您的同意前，我们将无法在后台收集您的个人信息。
        如果您不同意提供个人信息，您将无法使用智析的全部或部分功能和服务，或无法获得更个性化的功能，或无法参加某些活动，或无法收到我们的通知等。
        2.3 智析仅会在出现下列情况时收集您的个人信息：
        （1）
        在您注册智析账号时，我们至少会收集您的账户昵称、性别、电子邮箱、手机号码等信息。若您以其他方式关联登陆智析，我们会向关联第三方请求您的个人信息，对于我们要求但第三方无法提供的个人信息，我们仍可以要求您提供。如果您拒绝提供这些信息，将影响您使用智析或智析的相关功能。在您注册使用智析时，我们会对您进行实名验证，如果您拒绝提供有关信息，智析将拒绝向您提供服务。
        （2） 在您使用智析提供的位置定位服务时，我们会收集您的位置信息、设备信息等。智析保证在您的设备使用定位服务时不会收
        （3） 在您使用我们提供的搜索服务时，我们会收集您搜索的关键字信息、搜索历史记录、设备信息【包括您使用的设备属性、连接和状态信息，例如设备型号、设备标识符（如IMEI/
        AndroidID/ IDFA/ OPENUDID/ GUID/
        OAID）、设备MAC地址、电信运营商等软硬件特征信息】。为了提供高效的搜索服务，部分信息会暂时存储在您的本地设备中。在此，您需要注意的是，单独的搜索关键字信息无法识别您的个人身份，其不属于您的个人信息，因此我们有权以其他的目的对其进行使用；只有当您的搜索关键字信息与您的其他信息互有联系并可以结合识别您的个人身份时，我们会将您的搜索关键字信息作为您的个人信息，与您的搜索历史记录一同按照本政策进行处理与保护。
        （4） 在您使用智析提供的身份认证服务时，我们会收集您的姓名、身份证号、职业、有关身份证明等信息，智析对您的这些隐私信息会加以最大程度的保护，如果您不提供这些信息，我们将无法提供相关服务。
        （5） 当您参加智析的有关服务时，我们会收集您的姓名、学校名称、通讯地址、联系方式、银行账号等信息。这些信息是您收到转账或礼品的基础，如果您拒绝提供这些信息，我们将无法向您转账或寄送发票。
        （6） 智析会收集您设备的具体位置信息为您提供您所在城市的有关资讯，智析所收集的信息中不会涉及您设备的其他信息。
        （7） 当您在智析中使用第三方提供的服务时 ，智析视为您允许第三方收集您的订单信息、支付信息等，如果您拒绝第三方在提供服务时收集此类信息，将可能会导致您无法在智析中使用第三方服务。
        （8） 基于对您信息的有效保护并且在您同意的基础上，我们会对收集到的您的信息进行去标签化处理，以保护您的信息安全。在此希望您了解并接受在不透露您个人信息的前提下，智析有权对您的信息进行分析并予以商业化的利用。
        （9） 当您通过智析登录第三方应用时，第三方可能会通过智析获得您的个人昵称、头像等信息。如果您拒绝提供此类功能，您可以在智析相关设置中关闭。
        （10）
        当涉及国家安全与利益、社会公共利益、与犯罪侦查有关的相关活动、您或他人生命财产安全但在特殊情况下无法获得您的及时授权、能够从其他合法公开的渠道、法律法规规定的其他情形下，智析可能在不经过您的同意或授权的前提下，收集您的个人信息。
        （11） 在某些特殊情况下，智析会要求您提供相关证明等纸质版信息。在智析收到您的纸质版信息的30天内，智析会妥善处理您的信息并及时告知您。
        2.4 如在上述场景之外获得您的个人信息，将重新征得您的明示同意，并在获得您明示同意前向您充分说明应用场景与获取您相关信息的内容与范围。
        <h4> 三、 对Cookie、web beacon以及第三方SDK技术的使用</h4>
        3.1
        Cookie可以帮助网站辨认注册用户，计算用户数量，通常被各网站用来判定完成注册的用户是否已经实现登录。智析承诺，对cookie信息的研究仅用于提升服务/产品质量及优化用户体验之目的。同时，如不希望个人信息保留在cookie中，您可以对浏览器进行配置：选择"拒绝cookie"或"当网站发送cookie时通知您"，您知道，鉴于智析的服务是通过支持cookie来是实现的，完成关闭cookie的操作后，可能影响到您访问智析或不能充分取得智析的服务。您不禁用cookie时，可能会得到提示，是否在下一次进入此网站时保留用户信息以便简化登录手续（如一键登录）。
        3.2 智析使用web beacon的方法和目的与cookie是相同的。
        3.3 为了向您提供更好的服务或产品，智析会在下述情形使用您的个人信息：
        （1） 根据相关法律法规的要求；
        （2） 根据您的授权；
        （3） 根据智析相关服务条款、应用许可使用协议的约定。
        3.4 为了能够更好的完善智析的产品研发以及使用，为您提供更为多元化的服务，我们在智析App中采用了第三方提供的SDK。SDK（Software
        Development Kit）即软件开发工具包，是指用于为特定的软件包、软件框架、硬件平台、操作系统等创建应用软件的开发工具的集合。智析使用的
        SDK类型分别为：支持快捷注册或登录、优化浏览和信息发布功能、数据监测、故障收集分析、广告投放、提供支付功能、帐号安全性核验以及设备制造商和操作系统厂商的
        SDK。
        3.5
        此外，您已知悉并同意：在现行法律法规允许的范围内，智析可能会将您非敏感的个人信息用于市场营销，使用方式包括但不限于：智析会使用您所提供信息在智析平台中向您展示或提供广告和促销资料，向您通告或推荐智析的服务或产品信息，以及其他此类根据您使用智析服务或产品的情况所认为您可能会感兴趣的信息。其中也包括您在采取授权等某动作时选择分享的信息，例如当您新增好友、在动态中新增地标、使用智析的联络人汇入工具等。
        <h4>四、 个人信息的保护和安全措施</h4>
        4.1
        智析将尽一切合理努力保护其获得的用户个人信息，并由专门的数据安全部门对个人信息进行保护。为防止用户个人信息在意外的、未经授权的情况下被非法访问、复制、修改、传送、遗失、破坏、处理或使用，智析已经并将继续采取以下措施保护您的个人信息：
        （1） 我们的网络服务采取了传输层安全协议等加密技术，通过http等方式提供浏览服务，确保用户数据在传输过程中的安全。
        （2） 通过采取加密技术对用户个人信息进行加密保存，并通过隔离技术进行隔离。
        （3） 在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换、加密脱敏等多种数据脱敏技术增强个人信息在使用中安全性。
        （4） 设立严格的数据使用和访问制度，采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。
        （5） 采取专门的数据和技术安全审计，设立日志审计和行为审计多项措施。
        4.2 保护个人信息采取的其他安全措施
        （1） 通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。
        （2） 建立数据安全专项部门，负责安全应急响应组织来推进和保障个人信息安全。
        （3） 加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
        4.3 个人信息安全事件的通知
        （1） 如发生个人信息引发的安全事件，智析将第一事件向相应主管机关报备，并即时进行问题排查，开展应急措施。
        （2） 通过与全量用户发送通知提醒更改密码。还可能通过电话、短信等各种方式触达用户知晓，在智析公共运营平台运营宣传，制止数据泄露。
        4.4
        尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但智析仍然无法保证您的个人信息通过不安全途径进行交流时的安全性。因此，用户个人应采取积极措施保证个人信息的安全，如：定期修改账号密码，不将自己的账号密码等个人信息透露给他人。
        4.5 您知悉：智析提供的个人信息保护措施仅适用于智析平台，一旦您离开智析，浏览或使用其他网站、服务及内容资源，智析即没有能力及义务保护您在智析以外的网站提交的任何个人信息，无论您登录或浏览上述网站是否基于智析的链接或引导。
        4.6 网络环境中始终存在各种信息泄漏的风险，当出现意外事件、不可抗力等情形导致您的信息出现泄漏时，智析将极力控制局面，及时告知您事件起因、智析采取的安全措施、您可以主动采取的安全措施等相关情况。
        <h4> 五、 个人信息的存储</h4>
        5.1
        智析会采取合适的安全措施和技术手段存储及保护您的个人信息，以防止丢失、被误用、受到未授权访问或泄漏、被篡改或毁坏。您的个人信息存放在有密码控制的位于中国境内的服务器中，访问均是受到限制的。当您需要跨境信息传输服务时，智析会默认您继续使用中国境内的服务器。
        5.2 智析会依照个人信息的不同等级存储不同期限，存储期限严格按照法律及相关法规规定，最低期限不少于6个月。
        5.3 根据本条款的规定，我们仅允许有必要知晓这些信息的智析员工等第三方访问个人信息，并要求他们履行相应的保密义务。
        5.4 智析如涉及向境外传输个人信息，将会向用户明确告知并征得同意。
        <h4> 六、 个人信息的使用和对外提供</h4>
        6.1 未经您本人允许，智析不会向任何第三方公开（包括共享、转让、公开披露等方式）您的个人信息，下列情形除外：
        （1） 智析已经取得您或您监护人的授权或同意；
        （2） 司法机关或行政机关基于法定程序要求智析披露的；
        （3） 智析为维护自身合法权益而向用户提起诉讼或仲裁时；
        （4） 根据您与智析相关服务条款、应用许可使用协议的约定；
        （5） 在法律允许的范围内，为保障智析、智析用户以及社会公共利益免受损害时；
        （6） 符合您与其他第三人之间有关约定的。
        6.2 您可以向特定的对象发送您的照片、身份信息、位置信息等，也可以基于智析的服务向不特定人共享自己的照片、位置信息、身份信息等。当您因为您的共享行为导致您的信息发生泄漏等严重情况时，智析不承担相关法律责任。
        6.3 随着我们业务的发展，我们及我们的关联方有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。
        <h4>七、 个人信息的管理</h4>
        7.1
        当您完成智析的账号注册并进行合理和必要的身份验证后，您可以查阅、修改、删除您提交给智析的个人信息。一般情况下，您可随时浏览、修改、删除自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，您可能无法修改注册时提供的某些初始注册信息及验证信息。
        7.2 智析始终将对您个人信息的保护放在首位，同时，智析重视您对个人信息的关注。对于您的个人信息，您可以通过手机客户端等途径在线查询、修改、删除您的个人信息。
        7.3 您有权自主更新或更正您的个人信息，或授权智析客服进行信息更新、更正。在您进行信息更新更正之前，我们会首先验证您的身份，其次才能进行信息的更正与更新。
        7.4 如果您对本《隐私政策》或其中有关您个人信息的收集、使用、存储、保护等功能存在意见或建议时，您可以通过智析功能页面、或智析客户服务渠道反馈意见或投诉，智析会在收到您意见及建议的第一时间将反馈信息回复给您。
        7.5 您可以通过关闭智析部分功能的方式阻止智析获得您的个人信息，关闭部分功能之后，我们将无法向您提供相应的服务。
        7.6
        您可以自主要求注销智析账号以保障智析不再收集您的个人信息。您可以通过手机客户端注销账号，在您注销您的账号之前，智析将验证您的个人身份、安全状态、常用设备等信息。您注销账号的行为是不可逆的行为，一旦您注销您的账号，智析将即刻删除有关您账户的一切信息，并保证这些信息不会泄露，同时，您也无法通过已注销的账户获得智析的服务。
        7.7 如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。
        <h4>八、 对未成年人个人信息的特别保护</h4>
        8.1
        智析非常重视对未成年人个人信息的保护。若您是未满18周岁的未成年人，在使用智析的服务前，应确保事先取得监护人的同意。如您在智析上申请注册账号，智析将默认为您已得到前述同意。智析将根据国家相关法律法规及本《隐私政策》的规定保护未成年人的个人信息。
        <h4>九、 《隐私政策》的修改</h4>
        9.1 为给您提供更好的服务以及随着我们业务的发展，本《隐私政策》也会随之更新。但未经您明确同意，我们不会削减您依据当前生效《隐私政策》所应享有的权利。
        9.2 我们会通过在网站、移动端上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，以便及时了解最新的《隐私政策》。
        9.3 对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信、私信或在浏览页面做特别提示等方式，说明《隐私政策》的具体变更内容）。
        9.4 本政策所指的重大变更包括但不限于：
        （1） 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
        （2） 我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
        （3） 个人信息共享、转让或公开披露的主要对象发生变化；
        （4） 您参与个人信息处理方面的权利及其行使方式发生重大变化；
        （5） 我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
        （6） 个人信息安全影响评估报告表明存在高风险时。
        <h4> 十、 争议解决</h4>
        10.1 如果您对本《隐私政策》有任何疑问，请您联系智析客服咨询，我们会及时解决您的问题。
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'privacy',
  components: {},
  data () {
    return {
      isShow: false
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
    },
    closeModel () {
      this.isShow = false
    }
  }

}
</script>
